// extracted by mini-css-extract-plugin
module.exports = {"container":"_2jxePN","input":"_1S_ktU","label":"_3O-jcr","removeButton":"_15wnpC"};